import { FC } from 'react';
import cn from 'classnames';

import styles from './PsychicFeaturePallet.module.scss';
import { PsychicFeaturePallet } from './Pallet';

import type { IPsychicFeaturesArray } from '../config/declarations';

/* Nested Component */
const Stub = () => (
  <div className={styles.stub} />
);

/* Main Component */
export const PsychicFeaturesArray: FC<IPsychicFeaturesArray> = ({
  features,
  className,
}) => {
  if (!features?.length) {
    return <Stub />;
  }

  return (
    <div className={cn(styles.features, className)}>
      {features.map((feature) => (
        <PsychicFeaturePallet key={feature} feature={feature} />
      ))}
    </div>
  );
};
